import { z } from 'zod';

export const englishIqKindV2Schema = z.enum(['benchmark', 'skill_check']);

export type EnglishIqKindV2Type = z.infer<typeof englishIqKindV2Schema>;
